/* This example requires Tailwind CSS v2.0+ */

import { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { selectAuth } from 'containers/SingIn/authSlice';
import { useHistory } from 'react-router';
import { genTokenAction } from 'containers/SingIn/authAPI';
import Logo from "assets/images/splash_icon.png";
import Ripple from 'assets/images/ripple.gif';
import {useTranslation} from "react-i18next";

const GenToken = (props: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { programId } = useSelector(selectAuth);
  const history = useHistory()

  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    dispatch(genTokenAction(query.get('uid') || "", history, programId))
  }, []);


  return (
    <>
      <div className="min-h-full flex">
        <div className="flex-1 px-20 py-20">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div className="flex items-center justify-center logo-login" >
              <img
                className="h-16 w-auto my-10"
                src={Logo}
                alt="Workflow"
              />
            </div>
            <div className="">
              <div className="flex flex-col items-center justify-center">
                <div className="text-2xl content-center">
                  <h1 className="font-bold text-primary text-center">
                    {t('AUTH.TOKEN_GEN_PAGE_TITLE')}
                  </h1>
                </div>
                <div className="flex items-center justify-center mt-4">
                  <img
                      className="h-32 w-auto"
                      src={Ripple}
                      alt="Ripple"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default GenToken